import * as React from 'react';

import type WorkOrderModalViewModel from 'ab-viewModels/scheduleBoardWorkOrderModal.viewModel';

import { generateWorkLocationAddressStringIdentifier, getListOfAddedWorkLocationAddresses, getRemovedWorkLocationAddressesDictionary } from 'af-utils/workOrderModal.util';

import { SegmentLabel } from '@acceligentllc/storybook';

import AddressList from './AddressList';
import styles from './styles.module.scss';
import Changes from '../../Changes';

interface Props {
	workOrderDataToShow: WorkOrderModalViewModel;
	currentWorkOrderData: WorkOrderModalViewModel;
}

const _renderAddedAddressesResourcesPopover = (workOrderDataToShow: WorkOrderModalViewModel, currentWorkOrderData: WorkOrderModalViewModel) => {
	const listOfAddedAddresses = getListOfAddedWorkLocationAddresses(workOrderDataToShow, currentWorkOrderData);

	if (listOfAddedAddresses.length === 0) {
		return null;
	}

	return (
		<>
			<span className={styles['work-locations__added-address-info']}>List of addresses that were added in the meantime: </span>
			{
				listOfAddedAddresses.map((_address, _index) => (
					<div className={styles['work-locations__added-address-content']} key={`added-address-${_index}`}>
						{generateWorkLocationAddressStringIdentifier(_address)}
					</div>
				))
			}
		</>
	);
};

const WorkLocationsSection: React.FC<Props> = (props) => {
	const { workOrderDataToShow, currentWorkOrderData } = props;

	const removedAddressesDictionary = getRemovedWorkLocationAddressesDictionary(workOrderDataToShow, currentWorkOrderData);
	const isAtLeastOneAddressRemoved = Object.keys(removedAddressesDictionary).length > 0;

	const addedAddressesResourcesPopover = React.useMemo(
		() => _renderAddedAddressesResourcesPopover(workOrderDataToShow, currentWorkOrderData), [currentWorkOrderData, workOrderDataToShow]
	);

	return (
		<div className={`${styles['work-locations']} m-t-m`}>
			<Changes addedDataPopover={addedAddressesResourcesPopover} removedData={isAtLeastOneAddressRemoved} />
			<SegmentLabel
				label="Work Locations"
				tooltip="The location where work is being performed for this Work Order."
			/>
			<div className="m-t-m" />
			<AddressList
				addresses={workOrderDataToShow.addresses}
				removedAddressesDictionary={removedAddressesDictionary}
			/>
		</div>
	);
};

export default React.memo(WorkLocationsSection);
